import { BIDDING_TYPES } from "../../utils";
import { resolveSupplyDates } from "./generalDataStep";
import { buildOrderBodyCore } from "./orderPayloadCore";
import { isQuotedByLine } from "./serviceDetail";

/**
 * SINGLE SOURCE OF TRUTH for the `POST /order` + `POST /order/multiple` create
 * payload. Extracted verbatim from the pre-Carbon `Order.tsx#onSubmit` so the
 * request body stays BYTE-EQUIVALENT through the Carbon migration (Task 5,
 * ruling 1). The container decides *which* mutation to call (single vs. joint
 * vs. one-per-line); this function only shapes the array of order bodies.
 *
 * Task 6 (`OrderByRequest`) reuses this exact builder instead of re-deriving
 * the payload — pass it the same four inputs and it produces the identical
 * shape.
 */
export type BuildOrderPayloadArgs = {
  ordersToSubmit: any[];
  generalBidData: any;
  selectedType: { value: string } | null;
  selectedComplexType: { value: string } | null;
  user:
    | {
        id?: string;
        email?: string;
        fullName?: string;
      }
    | null
    | undefined;
};

export const buildOrderPayload = ({
  ordersToSubmit,
  generalBidData,
  selectedType,
  selectedComplexType,
  user,
}: BuildOrderPayloadArgs) =>
  ordersToSubmit.map((mat: any) => ({
    ...buildOrderBodyCore(mat, generalBidData, {
      selectedType: selectedType!,
      selectedComplexType: selectedComplexType!,
      user,
    }),
    // A service quoted line by line is one service; its quantities are on its lines.
    quantity: isQuotedByLine(mat) ? 1 : parseFloat(mat.quantity),
    // The per-item delivery date UI was removed for joint quotations; fall
    // back to the bidding window when the line carries no dates.
    ...resolveSupplyDates(mat, generalBidData),
    internalCode: mat?.internalCode
      ? mat?.internalCode
      : generalBidData.internalCode,
    initialPrice:
      selectedType!.value === BIDDING_TYPES.INVERSE
        ? parseFloat(mat.initialPrice)
        : null,
    minimumDecrement:
      selectedType!.value === BIDDING_TYPES.INVERSE
        ? parseFloat(mat.minimumDecrement)
        : null,
  }));
